import { useEffect, useState } from 'react';

export default function RoboKidsReceiptPage() {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const data = JSON.parse(sessionStorage.getItem('roboKidsRegistration') || '{}');
    if (!data.guardianName) {
      window.location.href = '/robokids';
    } else {
      setUserData(data);
    }
  }, []);

  const handleDownloadAndClose = () => {
    window.print();
    setTimeout(() => {
      sessionStorage.removeItem('roboKidsRegistration');
      window.location.href = '/';
    }, 1000);
  };

  if (!userData) return null;

  return (
    <div style={{ maxWidth: '700px', margin: '2rem auto', padding: '1rem' }}>
      <h1>🧾 Robo Kids Registration Receipt</h1>
      <p><strong>Guardian Name:</strong> {userData.guardianName}</p>
      <p><strong>Email:</strong> {userData.email}</p>
      <p><strong>Child’s Name:</strong> {userData.childName}</p>
      <p><strong>Child’s Age:</strong> {userData.childAge}</p>
      <p><strong>Shipping Address:</strong><br />
        {userData.address?.address1}<br />
        {userData.address?.address2 && (<>{userData.address.address2}<br /></>)}
        {userData.address?.city}, {userData.address?.state} {userData.address?.zip}
      </p>
      <p><strong>Class Start Date:</strong> {userData.startDate}</p>
      <p><strong>Registration Timestamp:</strong> {userData.timestamp}</p>

      <button
        onClick={handleDownloadAndClose}
        style={{
          marginTop: '2rem',
          padding: '0.75rem 1.5rem',
          fontSize: '16px',
          background: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
        }}
      >
        Download & Close
      </button>
    </div>
  );
}
